/**
 * What AppLocationShell last learned about a location, kept apart from the
 * shell so the delete dialog can forget an id without pulling in the shell's
 * page styles.
 *
 * A location is "known to open" only for a short while after a check said so
 * (APP_CACHE_TTL_MS, the same age the app's reads are trusted for). The held
 * overview alone is never trusted: it may be minutes old, and a location
 * deleted since (another tab, a co-admin) would open a page whose first op
 * answers 401, which sends a signed-in owner to sign in (review of A10).
 */
import { APP_CACHE_TTL_MS } from '../appData';

const confirmed = new Map<string, { user: string; at: number }>();

/** A check just said this person can open this location. */
export function rememberLocationOpens(locationId: string, user: string): void {
  confirmed.set(locationId, { user, at: Date.now() });
}

/** A recent check said it opens for this person, so no read is needed. */
export function recentlyConfirmed(locationId: string, user: string | null): boolean {
  if (!user) return false;
  const hit = confirmed.get(locationId);
  return !!hit && hit.user === user && Date.now() - hit.at < APP_CACHE_TTL_MS;
}

/** The location was deleted (or found gone): the next visit checks again. */
export function forgetLocationAccess(locationId: string): void {
  confirmed.delete(locationId);
}

/** Test seam. */
export function resetLocationAccessMemo(): void {
  confirmed.clear();
}
